export const en = {
    // Login screen
    modal_login_capital: 'LOGIN',
    placeholder_email_address: 'email',
    placeholder_password: 'password',
    tooltip_forgot_password: 'Forgot password?',
    log_in: 'Log in',

    // Register screen
    modal_signup_capital: 'SIGN UP',
    placeholder_repeat_password: 'repeat password',
    agree: 'I agree to the ',
    terms: 'Terms',
    modal_register_capital: 'REGISTER',
    full_name: 'Full name',

    // Price options
    choose_price: 'CHOOSE YOUR PRICE',
    subscription_price: 'Subscription',
    asset_price: 'Asset',
    paywall_subscription_text: 'You can cancel your subscription at any time.',
    modal_back: 'BACK',
    next_button: 'NEXT',

    // Payments screen
    pay: 'PAY',
    pay_with: 'PAY WITH PAYPAL',
    credit_card: 'credit card',
    payment_pay: 'Pay',
    payment_price: 'Price',
    placeholder_voucher_code: 'voucher code',
    placeholder_voucher: 'add voucher',
    card_number: 'card number',
    cardholder_name: 'cardholder name',

    // Forgot password
    forgot_pass_text: "We'll email a link to reset your password.",
    remember_pass: 'Remember password?',
    reset: 'RESET',

    // Set new password
    modal_enter_your_new_password: 'Enter your new password.',
    modal_please_check_your_email:
        'Please check your email and copy the token to proceed.',
    placeholder_token: 'token',
    new_password: 'new password',
    repeat_new_password: 'repeat new password',
    cancel: 'cancel',
    set: 'SET',

    // Change password
    update: 'update',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'My Details',
    member_since: 'Member since',
    purchases: 'My purchases',
    subscriptions: 'My Subscriptions',
    account_details: 'Account details',
    export_data: 'Export my data',
    delete_account: 'Delete account',
    email: 'Email',

    // Purchases/Subscriptions
    purchases_link: 'Purchases',
    subscriptions_link: 'Subscriptions',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Purchase history',
    purchased: 'Purchased',
    name: 'name',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    canceled: 'canceled',
    type: 'Type',
    next_transaction: 'next transaction',
    cancel_subscription: 'Cancel subscription',
    subscriptions_active: 'Active subscriptions',
    expires_at: 'Expires At',
    no_more_subscriptions: 'There are no more subscriptions.',
    no_available_subscriptions: 'There are no available subscriptions.',
    no_more_active_accesses: 'There are no more active accesses.',
    no_more_inactive_accesses: 'There are no more inactive accesses.',
    no_available_active_accesses: 'There are no available active accesses.',
    no_available_inactive_accesses: 'There are no available inactive accesses.',
    subscription: 'Subscription',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end',

    // Export data screen
    export_question: 'Are you sure you want to export your account data?',
    export: 'export',
    first_export:
        'Account Data Export action will export all personal data for your account. This includes the following:',
    second_export: 'Your personal information',
    third_export: 'List of your logins records',
    fourth_export: 'List of your subscriptions',
    fifth_export: 'List of your payments',
    sixth_export: 'List of your accesses to premium content',
    last_export: 'The export will be sent to your email address as attachment.',

    // Delete account screen
    delete_question: 'Are you sure you want to delete your account?',
    delete: 'delete',
    confirm: 'CONFIRM',
    first_delete:
        'Erase Account action will erase all your personal data from the system. This includes the following:',
    second_delete:
        'Personal information you provided during the registration process',
    third_delete:
        'Location and device information we gather during authentication process',
    fourth_delete:
        'All other personal information stored in other parts of our database',
    fifth_delete:
        'The only personal data we will keep in the system is one which is part of the transactions and subscriptions records due to other legislation we have to abide by.',
    sixth_delete:
        'In addition to the data erasure, your account will also be deactivated, which means that all your active subscriptions will be cancelled, all your currently active accesses to assets will be revoked and all your active login sessions including this one will be terminated. You will no longer be able to authenticate and purchase assets on this website. Your account information will no longer be accessible in any list to our staff.',
    seventh_delete:
        'This action might take 1-2 days to complete after which a confirmation email will be sent to your email address. The email will be erased from our system after successful delivery.',

    // Inputs validation
    required_field: 'Required field',
    email_field: 'please enter a correct email',
    number_field: 'Value must be a number',
    matchPass: 'the password did not match',
    minpass_field: 'must be at least 8 characters long',
    minname_field: 'must be at least 2 characters long',

    // Footer
    modal_terms: 'Terms',
    modal_privacy: 'Privacy',
    modal_more: 'MORE',
    modal_faq: 'FAQ',
    modal_protected: 'What is this?',
    logout: 'Logout',
    details: 'My details',
    preview_protected_by_inplayer: 'Protected by',
    modal_support: 'Support',

    // Dlc
    dlc_download: 'download',
};



// WEBPACK FOOTER //
// ./src/i18n/english.js